import { t } from "@lingui/macro"
import { observer } from "mobx-react"

import { Grid, Typography, Box } from "@mui/material"

import { useStore } from "src/store/lib/useStore"
import { AlertDetailModalStore } from "src/modals/alert-detail/store"
import { ModalTextField } from "src/components/ModalTextField"
import { TooltipWithIcon } from "src/components/Tooltips/TooltipWithIcon"

export const AlertContentSection = observer(() => {
    const store = useStore(AlertDetailModalStore)

    return (
        <Grid container sx={{ gap: 2 }}>
            <Grid item xs={12}>
                <ModalTextField
                    variant="default"
                    label={t`alerts-modal.title-label`}
                    value={store.formFields.get("title")}
                    onChange={store.formFields.setter("title")}
                    error={Boolean(store.formFields.error("title"))}
                    disabled={store.isReadOnly}
                    data-testid="alert-title-input"
                />
            </Grid>
            <Grid item xs={12}>
                <ModalTextField
                    variant="default"
                    label={t`alerts-modal.message-label`}
                    value={store.formFields.get("text")}
                    onChange={store.formFields.setter("text")}
                    error={Boolean(store.formFields.error("text"))}
                    disabled={store.isReadOnly}
                    rows={4}
                    data-testid="alert-message-input"
                />
            </Grid>
            <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                    variant="body1"
                    sx={{ mt: 3, color: (theme) => theme.palette.grey[900] }}
                >
                    {t`alerts-modal.cta-section-label`}
                </Typography>
                <Box sx={{ ml: 1, mt: 3 }}>
                    <TooltipWithIcon
                        tooltipText={t`alerts-modal.cta-section-tooltip`}
                    />
                </Box>
            </Grid>
            <Grid
                item
                xs={12}
                sx={{ display: "flex", flexDirection: "row", gap: 2 }}
            >
                <Grid item xs={6}>
                    <ModalTextField
                        variant="default"
                        label={t`alerts-modal.cta-label-label`}
                        value={store.formFields.get("cta_label")}
                        onChange={store.formFields.setter("cta_label")}
                        error={Boolean(store.formFields.error("cta_label"))}
                        disabled={store.isReadOnly}
                        data-testid="alert-cta-label-input"
                    />
                </Grid>
                <Grid item xs={6}>
                    <ModalTextField
                        variant="default"
                        label={t`alerts-modal.cta-url-label`}
                        placeholder="https://www.example.com"
                        value={store.formFields.get("cta_url")}
                        onChange={store.formFields.setter("cta_url")}
                        error={Boolean(store.formFields.error("cta_url"))}
                        disabled={store.isReadOnly}
                        data-testid="alert-cta-url-input"
                    />
                </Grid>
            </Grid>
        </Grid>
    )
})
